import { GifsResult, GiphyFetch } from '@giphy/js-fetch-api'
import { getChannelByUsername, getChannelGifsById } from '../util/channel-api'

export const fetchTrendingText = async (gf: GiphyFetch, offset: number, limit: number): Promise<GifsResult> => {
    try {
        const result = await gf.trending({ type: 'text', offset, limit })
        return result
    } catch (error) {
        return {
            data: [],
            pagination: { total_count: 0, offset, count: 0 },
            meta: { status: 500, msg: 'Error', response_id: '' },
        }
    }
}

export const fetchType = async (type: string, offset: number, limit: number): Promise<GifsResult> => {
    try {
        const channel = await getChannelByUsername({ slug: type })
        const feed = await getChannelGifsById(channel.id, { offset, limit })
        return feed
    } catch (error) {
        return {
            data: [],
            pagination: { total_count: 0, offset, count: 0 },
            meta: { status: 500, msg: 'Error', response_id: '' },
        }
    }
}

export const createFetchSearchType =
    (gf: GiphyFetch) =>
    async (searchTerm: string, offset: number, limit: number, _type: string): Promise<GifsResult> => {
        try {
            const result = await gf.search(searchTerm, {
                type: 'gifs',
                limit: limit,
                offset: offset,
                rating: 'g',
                lang: 'en',
            })
            return result
        } catch (error) {
            return {
                data: [],
                pagination: { total_count: 0, offset, count: 0 },
                meta: { status: 500, msg: 'Error', response_id: '' },
            }
        }
    }
